import React from 'react';
import StatusBadge from '../../components/StatusBadge';

export const SUBMITTAL_STATUS_LABELS = {
  DRAFT: 'Draft',
  INTERNAL_REVIEW: 'Internal Review',
  SUBMITTED_TO_CONSULTANT: 'Submitted to Consultant',
  PENDING_CONSULTANT_REVIEW: 'Pending Consultant',
  RETURNED_BY_CONSULTANT: 'Returned by Consultant',
  RECOMMENDED_TO_CLIENT: 'Recommended to Client',
  SUBMITTED_TO_CLIENT: 'Submitted to Client',
  PENDING_CLIENT_APPROVAL: 'Pending Client',
  RETURNED_BY_CLIENT: 'Returned by Client',
  RESUBMITTED: 'Resubmitted',
  APPROVED: 'Approved',
  APPROVED_WITH_COMMENTS: 'Approved with Comments',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
};

export const getSubmittalStatusTone = (status, isOverdue = false) => {
  if (isOverdue) return 'overdue-flag';
  const s = String(status || '').toUpperCase();
  if (s === 'DRAFT') return 'draft';
  if (s === 'INTERNAL_REVIEW') return 'internal-review';
  if (s === 'PENDING_CONSULTANT_REVIEW' || s === 'SUBMITTED_TO_CONSULTANT') return 'pending-consultant';
  if (s === 'PENDING_CLIENT_APPROVAL' || s === 'SUBMITTED_TO_CLIENT' || s === 'RECOMMENDED_TO_CLIENT') return 'pending-client';
  if (s === 'RETURNED_BY_CONSULTANT' || s === 'RETURNED_BY_CLIENT' || s === 'RESUBMITTED') return 'returned';
  if (s === 'APPROVED') return 'approved';
  if (s === 'APPROVED_WITH_COMMENTS') return 'approved-comments';
  if (s === 'REJECTED') return 'rejected';
  if (s === 'CLOSED' || s === 'CANCELLED') return 'closed';
  return 'draft';
};

export const formatSubmittalStatus = (status) => SUBMITTAL_STATUS_LABELS[String(status || '').toUpperCase()] || status || '—';

const SubmittalStatusBadge = ({ status, isOverdue = false, showOverdueFlag = true }) => {
  const tone = getSubmittalStatusTone(status, false);
  const label = formatSubmittalStatus(status);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <StatusBadge tone={tone}>{label}</StatusBadge>
      {showOverdueFlag && isOverdue && (
        <StatusBadge tone="overdue-flag">Overdue</StatusBadge>
      )}
    </span>
  );
};

export default SubmittalStatusBadge;
